export default "__VITE_ASSET__ef787075__"